<template>
    <div>
        <drag
            :ref="standard.guid"
            :transfer-data="standard"
        >
            <b-card
                :border-variant="(standardLocations[standard.guid].groups.length + standardLocations[standard.guid].units.length) == 0 ? 'danger' : null"
                no-body
            >
                <template #header>
                    <div class="d-flex align-items-center">
                        <div class="mr-3">
                            <font-awesome-icon :icon="['fad', 'arrows-h']" class="drag-handle" fixed-width />
                        </div>
                        <div>
                            <!-- {{standard.title}} -->
                            <span>{{standard.number}}</span> <span>({{ standard.year }})</span> 
                        </div>
                        <div class="ml-auto actions">
                            <span
                                v-if="(standardLocations[standard.guid].groups.length + standardLocations[standard.guid].units.length) > 0"
                            >
                                <tippy
                                    placement="left"

                                    :interactive="true"
                                >
                                    <template #trigger>
                                        <b-badge variant="success" class="tippy-trigger">
                                            {{(standardLocations[standard.guid].groups.length + standardLocations[standard.guid].units.length)}}
                                        </b-badge>
                                    </template>

                                    <div class="text-left">
                                        <div v-for="(location, index) in standardLocations[standard.guid].groups" :key="index">
                                            <a
                                                href="#"
                                                v-scroll-to="{
                                                    el: '#unit_group' + location.id,
                                                    offset: -144
                                                }"
                                                class="text-white"
                                            >
                                                <span v-if="location.title">
                                                    {{location.title}}
                                                </span>
                                                <span v-else>
                                                    no title
                                                </span>
                                            </a>
                                        </div>

                                        <div v-for="(location, index) in standardLocations[standard.guid].units" :key="'unit' + index">
                                            <a
                                                href="#"
                                                v-scroll-to="{
                                                    el: '#unit' + location.id,
                                                    offset: -144
                                                }"
                                                class="text-white"
                                            >
                                            <span v-if="location.title">
                                                {{location.title}}
                                            </span>
                                            <span v-else>
                                                no title
                                            </span>
                                            </a>
                                        </div>
                                    </div>
                                </tippy>
                            </span>
                            <div v-else>
                                <b-badge variant="danger">0</b-badge>
                            </div>
                        </div>
                    </div>
                </template>
                <div v-if="standard.description" class="card-body">
                    {{standard.description}}
                </div>
            </b-card>
        </drag>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({

    }),
    props: [
        'standard'
    ],
    computed: {
        ...mapState({
            unit_groups: state => state.unit_groups.unit_groups,
            standards: state => state.standards.standards,
        }),
        standardLocations () {
            let locations = {}

            _.forEach(this.standards, standard => {
                locations[standard.guid] = {
                    groups: [],
                    units: []
                }

                _.each(this.unit_groups, publication => {
                    _.each(publication.unit_groups, unit_group => {
                        if (_.find(unit_group.standards, {guid: standard.guid})) {
                            locations[standard.guid].groups.push(unit_group)
                        }

                        _.each(unit_group.units, unit => {
                            if (_.find(unit.standards, {guid: standard.guid})) {
                                locations[standard.guid].units.push(unit)
                            }
                        })
                    })
                })
            })

            return locations
        }
    }
}
</script>
